import React, { useState, useLayoutEffect, useRef, PropsWithChildren } from 'react';

import { Box } from '@vimeo/bokeh';

interface ISlideUpDownProps {
  /**
   * Should component be automatically open on initial mount.
   */
  automatic?: boolean;
  /**
   * Whether the children are visible
   */
  showing: boolean;
}

/**
 * Component that slides children up and down.
 * Replicated iris SlideUpDown component.
 */
export function SlideUpDown({
  automatic = false,
  children,
  showing,
  ...props
}: PropsWithChildren<ISlideUpDownProps>) {
  const ref = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState<number>(0);

  useLayoutEffect(() => {
    if (showing) {
      setMaxHeight(() => {
        if (ref.current) {
          return ref.current.scrollHeight;
        }

        return 0;
      });
    }
  }, [children, showing]);

  useLayoutEffect(() => {
    if (!automatic) setMaxHeight(0);
  }, [automatic]);

  return (
    <Box
      ref={ref}
      overflowY={'hidden'}
      transition={'all 200ms ease-in-out'}
      maxHeight={showing ? maxHeight : 0}
      {...props}
    >
      {children}
    </Box>
  );
}
